import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";
import userPlaceholder from "@/assets/user-placeholder.jpg";

interface Testimonial {
  content: string;
  name: string;
  role: string;
  company: string;
}

const TestimonialsSection = () => {
  const { t } = useTranslation();

  const testimonials = t('testimonials.items', { returnObjects: true }) as Testimonial[];

  const avatars = [
    "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=80&h=80&fit=crop&crop=face",
    "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face",
    "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face"
  ];

  return (
    <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
      {testimonials.map((testimonial, index) => (
        <Card key={index} className="text-left hover:shadow-elegant transition-shadow duration-300">
          <CardContent className="pt-6 pb-6">
            <div className="flex items-center mb-4">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="h-4 w-4 text-warning fill-current" />
              ))}
            </div>
            <p className="text-muted-foreground mb-6 italic leading-relaxed">{testimonial.content}</p>
            <div className="flex items-center">
              <img 
                src={avatars[index] || avatars[0]} 
                alt={testimonial.name}
                className="w-12 h-12 rounded-full mr-4 object-cover"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = userPlaceholder;
                }}
              />
              <div>
                <div className="font-semibold text-foreground">{testimonial.name}</div>
                <div className="text-sm text-muted-foreground">{testimonial.role}, {testimonial.company}</div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default TestimonialsSection;
